const ID = 'translate';

export default ID;
